export type PlacelistType = {
  id: string;
  title: string;
  artists: string[];
  about: string;
  content: string;
  places: PlaceType[];
};

export type PlaceType = {
  name: string;
  category: string;
  map: string;
  spotify: string[];
  content: string;
  images: string[];
};

export const placelist1: PlacelistType = {
  id: "tsuji-imai",
  title: "（アソビ）ギナーズラック",
  artists: ["imai（group_inou）", "辻友貴（cinema staff）"],
  about:
    "初めて阿蘇を訪れたimaiと辻。group_inouとcinema staffとして同時代の音楽シーンを牽引し、長年交流を重ねる彼ら。友人同士だからこそのリラックスした雰囲気のなかで訪れる場所はどこも刺激的。阿蘇ビギナー2人の遊びに満ちた旅は、あまりにも出来すぎていた。",
  content:
    "初めて阿蘇を訪れたimaiと辻。group_inouとcinema staffとして同時代の音楽シーンを牽引し、長年交流を重ねる彼ら。友人同士だからこそのリラックスした雰囲気のなかで訪れる場所はどこも刺激的。阿蘇ビギナー2人の遊びに満ちた旅は、あまりにも出来すぎていた。",
  places: [
    {
      name: "香辛喫茶 Lion Curry",
      category: "食事",
      map: "https://goo.gl/maps/hZhvcMQTcQiMWaJB8",
      spotify: [
        "https://open.spotify.com/embed/track/4C8GVfHtHKftmM9NVzfIqB?utm_source=generator",
        "https://open.spotify.com/embed/track/3fPhSGnlSorRpDhIui8bfZ?utm_source=generator",
      ],
      content:
        "阿蘇に到着した2人が最初に訪れた場所は、バンドマンだった店主が経営するスパイスカレー屋。店名の「Lion」は、店主が組んでいたバンド名が由来だという。無類の酒好きの辻に「酒に合う」と言わしめたスパイスカレーは、列をなすほど地元でも人気の味。imaiも「音楽家の作るカレーはなんでこうも美味しいのでしょうか？誰か僕の代わりに研究して下さい！」とその味を堪能し、「ウミネコサウンズのおさむさんもミュージシャンでカレー屋さん」と、この場所に紐づく音楽としてウミネコサウンズの「春はまだかい」を選曲。辻は、この店を紹介してくれた熊本発のバンド、Shikiの「Venom」を選んだ。「紹介してくれたバンドShikiのメンバー杉本さんに愛を込めて」。",
      images: ["_MG_3510.jpg", "_MG_3505.jpg", "_MG_3474.jpg"],
    },
    {
      name: "そらふねの桟橋",
      category: "アウトドア",
      map: "https://goo.gl/maps/t9vmDUzYrgUa63XAA",
      spotify: [
        "https://open.spotify.com/embed/track/2nFRaREPvleyRg1ABMT4pd?utm_source=generator",
        "https://open.spotify.com/embed/track/5v5ljtsZJY7KhCanQGsneK?utm_source=generator",
      ],
      content:
        "「Lion Curry」で腹を満たしたあとは、身体を動かして大自然を堪能したい。「そらふねの桟橋 」は田子展望所の山道を約10分歩いた先にある。桟橋からのパノラマ風景はもちろんのこと、辿り着くまでの山景も必見。そよともしない静まり返った山あいでは、思わずやまびこを聴きたくなる。「『やっほー！』のやまびこがあまりにも美しいディレイで感動しました。いきなり青春しちゃったなー。金色の草がキラキラしていて、頭の中ではTeenage Fanclubの『Going Places』が流れていました」とimai。辻は「澄んだ空気、綺麗な風景を見ると、美しいアンビエントミュージックを聴きたくなりますね」と Hammockの「God Send Us a Signal」を選曲した。さらに、阿蘇の雄大さを早速体感したimaiは、自身にとっての自然の存在について言及する。「コロナ禍でみんながストレスを抱えて対立や強い意見が散見されるなかで、自然を感じられる場所に何度か訪れて気分転換していました。MONO NO AWAREの「そこにあったから」でも歌われているように、人間と違って自然はただそこにあるだけで、何も返ってこない。だからこそ救われます」。 ",
      images: ["_MG_3578.jpg", "_MG_3521.jpg", "_MG_3525.jpg"],
    },
    {
      name: "鍋ヶ滝",
      category: "アウトドア",
      map: "https://goo.gl/maps/ELguHimQGwKksUcY7",
      spotify: [
        "https://open.spotify.com/embed/track/0FpZLGAuVUKGpxGreWtWTm?utm_source=generator",
        "https://open.spotify.com/embed/track/59y8j9XS7rnXXmub1TvQUf?utm_source=generator",
      ],
      content:
        "滝を裏側から見たことはあるだろうか。鍋ヶ滝は滝壺の奥で流れ落ちる水を眺めることができる、いわゆる「裏見の滝」。木漏れ日が差し込む滝壺は、imaiに爽快感と癒しを与える。「Melt-Bananaの『Circle Jack』のような極度に激しい音楽を聴くと爽快感を覚えるのですが、鍋ヶ滝もそんな感じでした。一周回って癒し系！」。一方辻は、鍋ヶ滝を「つまみになる景色」と表現。imaiも「大自然のなかって最高だよね」と呼応する。酒を嗜みたくなるほどの光景に、辻は「あのすごい自然を目の前に、『自分生きてるなぁ』って感じてる時に聴きたくなる曲です」とeastern youthの「ソンゲントジユウ 」を紐付ける。",
      images: ["_MG_3659.jpg", "_MG_3633.jpg", "_MG_3663.jpg", "_MG_3628.jpg"],
    },
    {
      name: "OGUNIYA JERSEY",
      category: "買い物",
      map: "https://g.page/ogunijersey?share",
      spotify: [
        "https://open.spotify.com/embed/track/4gD68gReo8iXcV9FeRTyQL?utm_source=generator",
        "https://open.spotify.com/embed/track/7hzgk557YLr0722EFkmp9Z?utm_source=generator",
      ],
      content:
        "阿蘇では自然だけでなく、雄大な土地が生み出した牛乳も味わいたい。鍋ヶ滝から車で約10分、ふらりと立ち寄った道の駅小国内のジャージーソフト屋「 OGUNIYA JERSEY」のジャージーソフトと牛乳の濃厚で優しい味わいに、imaiと辻は感動を覚える。「milkと言ったらこのバンドのことを思い出します」と、Neutral Milk Hotel 「Two-Headed Boy」を選んだ辻は、「牛乳でこんなに感動したことないです」と言う。ジャージーソフトに加えて、搾りたての冷たい牛乳とホットミルクも絶対に味わうべき一品だ。特にホットミルクが気に入ったimaiは、「ホットミルクのシルキーな口当たりはディアンジェロのグルーヴでした。ソフトクリームに行きがちだけど、ホットミルクもマストで！」と振り返った。",
      images: ["_MG_3733.jpg", "_MG_3700.jpg", "_MG_3691.jpg"],
    },
    {
      name: "河津酒造",
      category: "酒造",
      map: "https://goo.gl/maps/Kgbqz8rpkJpD1UKM7",
      spotify: [
        "https://open.spotify.com/embed/track/4gD68gReo8iXcV9FeRTyQL?utm_source=generator",
        "https://open.spotify.com/embed/track/3DTRil2jPOSKRVazEToelS?utm_source=generator",
      ],
      content:
        "「OGUNIYA JERSEY」と同じく、道の駅小国に店舗を構える「河津酒造」が気になり、imaiと辻は近くにある酒蔵を見学させてもらえることに。東京のIT企業で勤務したのち、2011年に3代目として酒蔵を継いだ現当主から話を聞いた。当主が話す河津酒造のこだわりに、2人は音楽と日本酒づくりを重ね合わせる。この場所を表す音楽にRei Harakamiの「Grief & Loss」を選んだimaiは、「『敢えて古い機械や手法を使う』という『効率/非効率』の話をされていたのですが、やっぱり一台の機材を使い倒していたハラカミさんが浮かびます。ハラカミさんもお酒が大好きでしたよね」と語る。辻も同じくものづくりのスタイルに感銘を受け、旅の車内で流れた往年のバンドの楽曲を選ぶ。「昔から活動し続けてその時代の音や録音技術も大切にしつつ、モダンな流れも入れていく感じがFoo Fightersを想起させます。車内ラジオで流れていたので彼らの『Shame Shame』を」。日本酒の多様性が強まる今、「100年後まで誰かが乾杯してくれるお酒」を作り続けていくために、酒造の強みを生かす「非効率」と、より良い品質を目指す「効率」を同居させることを重視する河津酒造。そのスタイルにより生み出した甘口の日本酒「純米吟醸 花雪」は、「純米酒大賞2016純米吟醸酒部門金賞」を受賞した。",
      images: ["_MG_3837.jpg", "_MG_3767.jpg", "_MG_3910.jpg"],
    },
    {
      name: "扇",
      category: "食事",
      map: "https://goo.gl/maps/mmheZBofXgQ2M5NUA",
      spotify: [
        "https://open.spotify.com/embed/track/5tP1KB1MxwlhqGNlFQMXMc?utm_source=generator",
        "https://open.spotify.com/embed/track/1f82gDcHIxzuT3yEawY5GE?utm_source=generator",
      ],
      content:
        "辻の居酒屋に対する鋭い嗅覚で、「これぞまさに居酒屋」と言うべき店に出会った。それが内牧の「阿蘇プラザホテル」向かいに佇む居酒屋「扇」。レーサーとしても活躍するタレントの近藤真彦も訪れる場所だ。割烹着を身に纏った日本酒好きの女将が1人で切り盛りし、天草の燻製かまぼこや馬のアキレス腱を煮込んだおでんの湯気が立ち上る店内では、ムーディーな昭和歌謡が響き渡る。美川憲一の「さそり座の女」が流れ、imaiは「M-1でモグライダーがネタにしていたこの曲がかかった瞬間ぶちあがりました。80歳のお母さんが一人で切り盛りしている最高のお店」と気持ちが昂る。酒がすすむ情緒溢れる雰囲気で、imaiと辻の話にも花が咲く。「こういう最高な居酒屋だと話が弾むわけで。imaiさんと音楽のこと語り合えた感じが堪らないってことで、imaiさんの『Alone 』を選びました」。",
      images: ["_MG_4002.jpg", "_MG_3997.jpg", "_MG_3993.jpg", "_MG_3952.jpg"],
    },
    {
      name: "阿蘇神社",
      category: "神社",
      map: "https://goo.gl/maps/7KD4s7XnRE6nHZoz9",
      spotify: [
        "https://open.spotify.com/embed/track/2HbDLvUR0SA1o9BDMAqqNM?utm_source=generator",
        "https://open.spotify.com/embed/track/3YQ7hYxZ2w2tVvla6yAuy3?utm_source=generator",
      ],
      content:
        "阿蘇市一の宮町の「阿蘇神社」は、全国に約500社ある「阿蘇神社」の総本社。現在は熊本地震による被害からの復旧工事を行っている。「神秘的なものを感じると聴きたくなる音楽です」と、辻はJulien Baker、 Phoebe BridgersとLucy Dacusの3人によるBoygeniusの楽曲「Ketchum.ID」をこの場所に紐付けた。社殿を参観したのち、2人は十種類の縁起物のいずれかが入った「幸福おみくじ」をひいた。imaiは延命長寿や金運招来を表す亀のお守りが納められたものをひき当て、お守りの可愛さに喜ぶ。「おみくじに付いてくる金の小さなカメが可愛かったので、PAS TASTAの『turtle thief』を」。",
      images: ["_MG_4036.jpg"],
    },
    {
      name: "手打ちそば 日出や",
      category: "食事",
      map: "https://goo.gl/maps/9RRtRYJPYzcsKsbk6",
      spotify: [
        "https://open.spotify.com/embed/track/3svnJmqz5Ol2Ba14zevaCn?utm_source=generator",
        "https://open.spotify.com/embed/track/2OXOhWojqfEcPxTDN9C0iE?utm_source=generator",
      ],
      content:
        "南阿蘇久木野産の蕎麦粉を石臼で自家製粉したそばを提供する「日出や」。阿蘇産の自然薯を使用したとろろそばを味わった2人。その味もさることながら、店内に置かれたバスドラムやコンガにも目を向けたい。レゲエやインド音楽好きの店主は、以前レゲエバンドをやっていたという。熊本地震により被害を受ける以前はドラムセットが店内にあり、友人であるLITTLE TEMPOのメンバーを招いたスティールパン教室や音楽ライブを開催していた。それを聞いた2人は興奮。辻はLITTLE TEMPOの「Over the rainbow」を、imaiはキセルの「ハナレバナレ」を選曲。「店長さんがLITTLE TEMPOとお知り合いとの事で、店内ではキセルが流れていました。キセルが大好きで、『新宿時代のリキッドルームに観に行ったな』とか思い出しました。LITTLE TEMPOの内田直之さんがミックスされているアルバムから1曲」。",
      images: ["_MG_4069.jpg", "_MG_4068.jpg", "_MG_4061.jpg", "_MG_4058.jpg"],
    },
    {
      name: "高森湧水トンネル公園",
      category: "アウトドア",
      map: "https://goo.gl/maps/17FeQYw72svRs3Xi6",
      spotify: [
        "https://open.spotify.com/embed/track/2mlIzqDE7RaMaMx1UPdsXL?utm_source=generator",
        "https://open.spotify.com/embed/track/2QP3GjOPJkwxt7apCmw2BA?utm_source=generator",
      ],
      content:
        '鉄道建設のために掘削していた岩盤の跡地にできたトンネル公園内には2055mにわたる水路が続く。地元の小中学生手作りの作品、イルミネーションやオブジェを目にしながら水路沿いの歩道を進むと、最後に行き着くのは仕掛け噴水「ウォーターパール」。小さな頃から水が好きだったimaiは、ストロボの光により不思議な動きをする水玉に、「チープで幻想的な照明や謎のオブジェで笑っていると、最後に"ウォーターパール"でカマされる感じはCeephax Acid Crewの『Essex Remblance』を連想しました。最後まで油断するなよ！」と大興奮。身を乗り出してウォーターパールの正体を解明しようとしていた辻は「絶妙なB級感とワクワクするサイケ感」と、トンネル公園の雰囲気にThe Flaming Lipsの「The Yeah Yeah Yeah Song」を重ね合わせる。',
      images: ["_MG_4134.jpg", "_MG_4127.jpg", "_MG_4103.jpg"],
    },
    {
      name: "草千里ヶ浜",
      category: "アウトドア",
      map: "https://goo.gl/maps/wPLLkxFZhR6hkjEb8",
      spotify: [
        "https://open.spotify.com/embed/track/48UPSzbZjgc449aqz8bxox?utm_source=generator",
        "https://open.spotify.com/embed/track/3uZDobGcvgPNlR5mXCYv5w?utm_source=generator",
      ],
      content:
        "まだ雪解け前の草千里ヶ浜を訪れた2人。広大な土地に異国の雰囲気を感じた辻は「なんとなくこの曲が思い浮かびました 」とRed Hot Chili Peppers「Californication」を挙げる。よく国内の自然を感じに行くimaiだが、「とても日本とは思えない壮大な景色！そりゃあ心も浄化されますよ。久々にこんな規模の自然を感じました」と草千里ヶ浜の景色に圧倒された。自然と同様、コロナ禍でimaiの心を救ったのは音楽。「コロナでどこも行けなかった時は、リョウコ2000の『Humming Bird』や、パソコン音楽クラブのアルバム『See-Voice』のような音楽に救われました」。",
      images: ["_MG_4275.jpg", "_MG_4269.jpg"],
    },
    {
      name: "おべんとうのヒライ阿蘇立野店",
      category: "買い物",
      map: "https://goo.gl/maps/SE3jYHbsKoCks5S28",
      spotify: [
        "https://open.spotify.com/embed/track/5XtZpzK2QfBCRG93IQznkW?utm_source=generator",
        "https://open.spotify.com/embed/track/176UHHdZMkujwcQdDT7xgn?utm_source=generator",
      ],
      content:
        '阿蘇を巡る旅の最後に訪れたのは熊本発の惣菜・弁当ショップ「ヒライ」の阿蘇立野店 。地域に根ざし、人々の生活に寄り添うヒライが生み出した「ちくわサラダ」は、いまや熊本定番の料理。ちくわサラダをはじめとする惣菜や弁当、イートインメニューの多彩なラインナップに、辻とimaiも思わずたじろぐ。辻は「今のトレンドも抑えたあのカオスな品揃え、モダンなプログレでしょう」と、ヒライをblack midiの「John Limai」になぞらえた。一方imaiはヒライへのリベンジを誓う。「俺たちの終着駅"ヒライ"！存在が大きすぎてとても一回では把握する事が出来ませんでした。帰り道にすごい夕陽が出ていて、横沢俊一郎の『プロローグ』で歌われる＜エンドロールから 始まる打ち上げ花火＞という一節が浮かびました。また来ます！！！」。',
      images: ["_MG_4316.jpg", "_MG_4300.jpg", "_MG_4299.jpg"],
    },
    {
      name: "高森駅",
      category: "アウトドア",
      map: "https://goo.gl/maps/YjTFHwsH5hRe8ujC9",
      spotify: [
        "https://open.spotify.com/embed/track/0dcL4iqX2uzYMPzUM5tj2k?utm_source=generator",
        "https://open.spotify.com/embed/track/5QAEo7jpRrrHuo3mMrw0gh?utm_source=generator",
      ],
      content:
        "高森湧水トンネル公園の駐車場で南阿蘇鉄道のトロッコ列車の看板を見つけたimaiと辻は、列車に乗るべく高森駅へと向かう。駅舎内に掲示された、熊本地震からの復興を応援する漫画家・原作者117名のメッセージを見てひとしきり感動したのち、2人はトロッコに乗車。赤い車体に、辻はくるりの「赤い電車 」を連想する。2人を乗せた貸し切りのトロッコ列車は、車窓からの眺めを解説する車掌のトークとともに、現在運行する区間の終点「中松駅」を目指す。車掌のテンポの良いトークは必聴。「電車に乗る事も気を遣うような時代に、まさかの貸し切りでついついはしゃいでしまいました。車掌さんのアナウンスもジャングルクルーズ感があって良い。心が少年に戻ったので、あの頃大好きだったこの曲を」とimaiはスピッツの「グラスホッパー」を選ぶ。",
      images: [
        "_MG_4251.jpg",
        "_MG_4244.jpg",
        "_MG_4224.jpg",
        "_MG_4217.jpg",
        "_MG_4209.jpg",
        "_MG_4201.jpg",
        "_MG_4197.jpg",
        "_MG_4142.jpg",
      ],
    },
  ],
};

export const placelist2: PlacelistType = {
  id: "natsumetomoyuki",
  title: "愛は資本主義じゃない",
  artists: ["夏目知幸"],
  about:
    "長い歴史をかけて形成された阿蘇のカルデラは、埋立地の千葉県浦安市で生まれ育った夏目知幸の知的好奇心を刺激する。高く透き通った阿蘇の空に比例するように、明るくて暖かい街の人たち。初めてなのにどこか暖かい、そんな阿蘇の魅力を伝えるプレイスリスト。",
  content:
    "30万年程前に数回起きたとされる噴火によって形成された阿蘇のカルデラ地形。想像も及ばないスケールの時間の流れは、千葉県浦安市で生まれ育った夏目知幸の知的好奇心を刺激する。「浦安の埋立地エリアは高低差がないフラットな土地。人工的に作られた街なので、神社仏閣もありません。真逆と言っていい阿蘇にはとても興味を引かれます」。山以外に遮るものがなく、高く透き通った阿蘇の空に比例するように、明るくて暖かい街の人たち。初めてなのにどこか暖かい、そんな阿蘇の魅力を伝えるプレイスリスト。夏目が阿蘇で出会ったのは、面倒見が良すぎるほどの店の人々と見飽きることのない大自然。愛はおしゃれでもなければ、対価を払うものでもない。決められた枠組みや画面のなかでの生活に疲れたら訪れたい阿蘇の場所。",
  places: [
    {
      name: "父娘庵",
      category: "食事",
      map: "https://g.page/oyakoan?share",
      spotify: [
        "https://open.spotify.com/embed/track/6gB7OjDWIQSR7uzwHYxAO9?utm_source=generator",
      ],
      content:
        "住宅街にひっそりと構える父娘庵（おやこあん）は、ハンバーグ定食や阿蘇産の黒毛和牛を使ったステーキセットなどが味わえる定食屋で、いつも多くの地元のお客さんで賑わっている。料理人として修行を積んだ店主が「亡くなった娘と一緒に店を出す」という長年の夢を実現させたのがこの店で2017年のオープン以来、様々なお客さんをもてなしてきた。亡き娘の描いた絵が店の至るところに飾ってあり、東京で歌手として活動する息子・水瀬団が店の広報担当で、家族一丸となって今日も営業している。「愛に溢れていてまるで実家のよう」と夏目が語る店の雰囲気は、お母さんにご飯のおかわりを頼むついでに、身の上話もしたくなってしまうような温かさがある。店主いわく「事前に相談してもらえれば、離乳食から貸切営業まで対応可能」とのことで、これまでリクエストされたメニューの数だけ、訪れた人のドラマがあった。夏目が選曲したのは、1970年代に活躍したブラジルの歌手・Toni Tornadoの「Cabeca Oca」。「楽しいお店だったので、楽しい曲を。旅の最初にノリよく行きたい感じにぴったりの曲です」。",
      images: ["_MG_4391.jpg", "_MG_4376.jpg", "_MG_4379.jpg"],
    },
    {
      name: "上色見熊野座神社",
      category: "神社",
      map: "https://goo.gl/maps/QGmS1rfX97zMFujp6",
      spotify: [
        "https://open.spotify.com/embed/track/4QNQYh76GRt6L3asf6LZlo?utm_source=generator",
      ],
      content:
        "上色見熊野座神社は、阿蘇・高森町にある四大熊野座神社の1つで、国産みの神である伊邪那岐命（イザナギノミコト）、伊邪那美命（イザナミノミコト）を祀っている。両側に広がる背の高い杉林に日の光を遮られた参道を1歩ずつ上がるたび、静寂でひんやりとした空気が鮮明になり、「神域さ」を感じる場所だ。「ゾーンが変わるような感じがとてもよかったです」と夏目。「『結界を知らせるための神社は境内の道をまっすぐには作らないことがある』と、以前聞いたことを思い出すような、緩やかなカーブがかかった本殿へのアプローチ。何かに誘われている感覚があってワクワクしました。」。参拝をすませたら、神社の奥にある10メートルほどの穴が空いた「穿戸岩（うげといわ）」も見逃せない。夏目いわく、「光の差し方や風の抜け方がとてもよくて、祈りたくなるような雰囲気を感じました」。選曲は、Luiz Bonfa の「Enchanted Mirror」。「神秘的な場所で、ゲームをよくやる僕にとってはRPGゲームの重要な場所のようにも感じました。優しい感じもあったので、こういう曲が合うと思います」。",
      images: ["_MG_4418.jpg", "_MG_4411.jpg", "_MG_4427.jpg"],
    },
    {
      name: "白川水源",
      category: "アウトドア",
      map: "https://goo.gl/maps/S6ULcLAkHuEFGm9LA",
      spotify: [
        "https://open.spotify.com/embed/track/5wSagCWflNwJ1xM59ZKw6O?utm_source=generator",
      ],
      content:
        "「火の国・熊本とはいえ、水源もたくさんあって、土地がいきいきとしているのがとても印象的でした」と語る夏目が訪れたのは白川水源。60トンもの水が毎分湧き出ていて、熊本市内を流れる白川の源にもなっている、阿蘇を代表する水源だ。水面に映る木々の反射は、鏡を見ているように美しく、水の透明度も目を見張るほど。街の至るところにも、他の多くの水源を見ることができる阿蘇は、歩いているだけで「自然の循環」を体感できる。「まず溶岩があって、そこに水が流れて水源が多くできたんだろうなと、大地や山のことについて考えてしまう。阿蘇はとにかくスケールが大きい場所だなと思います」と夏目。そんな白川水源には、ブラジルのオルタナティブロックバンドの曲「Sorbe o Tempo」をセレクト。「すごく瑞々しいのが好きでたまに聞く彼らのヒット曲です。軽くて、自然。ちょっと青春っぽい匂いがする曲を」。",
      images: ["_MG_4464.jpg", "_MG_4488.jpg", "_MG_4481.jpg", "_MG_4502.jpg"],
    },
    {
      name: "火の山トンネル",
      category: "アウトドア",
      map: "https://goo.gl/maps/1v9aF1nr6Vi2enmu7",
      spotify: [
        "https://open.spotify.com/embed/track/6658u0EPu6u0x9r5A4qT4h?utm_source=generator",
      ],
      content:
        "阿蘇パノラマラインから阿蘇山頂に向かう途中に位置する火の山トンネル一帯は、どれだけ近づいても見上げずにはいられない、雄大な山の峰が連なっている。「トンネルが異世界へと続くエントランスみたいで、冒険心をくすぐられるような高揚感が楽しかった」と夏目が語るように、トンネルを抜けると見えてくるのは、どこまでも続く草原や噴火したばかりの阿蘇山から延々と溢れ出る煙だ。「ニュースでみた噴火の映像を思い出しました」。目の前に広がる大自然に圧倒され、「今噴火したら終わるな」という自然への畏怖の念をも感じてしまう。「スケールの大きい景色に合う音楽を考えてたら、意外とこういう曲かも」と、夏目はKhotinの「Groove 32」をセレクト。",
      images: ["_MG_4526.jpg", "_MG_4571.jpg", "_MG_4544.jpg", "_MG_4605.jpg"],
    },
    {
      name: "大観峰",
      category: "アウトドア",
      map: "https://goo.gl/maps/BxDhj5885UwX7pBU7",
      spotify: [
        "https://open.spotify.com/embed/track/4CeeEOM32jQcH3eN9Q2dGj?utm_source=generator",
      ],
      content:
        "大観峰は、阿蘇の山々を360度見渡す限り楽しめる絶景スポットだ。阿蘇を訪れたら必ず立ち寄りたい。「あまりない地形に立たされている感じがした」と夏目。夕暮れ時は、自然が作り出したとは思えない、綺麗な紫や青が混じったパステルカラーが、山際をなぞるように広がり幻想的な景色を味わうことができる。また、ここから見える阿蘇五岳はお釈迦様の寝姿に見えることから「涅槃像」とも呼ばれていて、お坊さんからの信仰もあるのだそう。\n「大観峰から見える阿蘇山＝涅槃像。英語で涅槃仏を『リクライニング・ブッダ』というのはちょっと違うような気もしますが、涅槃といえばNirvana。そして、10代か20代前半の若い男の子たちがはしゃいでいたり、隣県ナンバーの車で訪れた若い子たちも楽しそうにしてたので、もうこの曲しかないだろうと思います」と夏目。Nirvanaの「 Smells like Teen spirit」を、箸が転んでもおかしい世代と阿蘇の涅槃にむけて選曲。",
      images: ["_MG_4651.jpg", "_MG_4626.jpg", "_MG_4659.jpg"],
    },
    {
      name: "酒房 筍ん子",
      category: "食事",
      map: "https://goo.gl/maps/drex3Feu2Tcj1dx88",
      spotify: [
        "https://open.spotify.com/embed/track/4rB8ebMrJRYoWCyyWqs585?utm_source=generator",
      ],
      content:
        "「提灯をすぎて、奥まった細い道を突き当たったとこにある引き戸、という店までのアプローチからよかった」と振り返るのは、地酒と郷土料理が味わうことができる居酒屋・酒房 筍ん子。家族で経営しているこの店は、料理も雰囲気も暖かみを感じることのできる店だ。「女将さんの日本酒の説明もすごく丁寧で、昼間に行った水源で感じた水の柔らかさを再確認できました。1日阿蘇を巡った体験がお酒として抽出され、味わえたのもとてもよかったです」と夏目。「からし蓮根などの地元のものはもちろん、自家製ソースのナポリタンも最高でした」。選んだ曲は、阿久悠の作詞で1974年リリースされた伊藤咲子の「ひまわり娘」。「昭和っぽい感じからこの曲にしました。イントロがThe Rolling Stonesの『Ruby Tuesday』みたいで洒落てるんです」。",
      images: ["_MG_4679.jpg", "_MG_4759.jpg", "_MG_4672.jpg", "_MG_4768.jpg"],
    },
    {
      name: "地獄温泉 すずめの湯",
      category: "温泉",
      map: "https://goo.gl/maps/eyahD8gGVhQj4tK99",
      spotify: [
        "https://open.spotify.com/embed/track/53xtrYKwCtkjxgRrDA8vgg?utm_source=generator",
      ],
      content:
        "地獄温泉は200年以上の歴史を持つ阿蘇の名湯だ。2016年の熊本地震で館内の大部分が被害を受けるも、残った部分を中心に復興を開始。震災以前は混浴だったすずめの湯は、復興を機に着衣入浴で性別、性自認にかかわらずいつでも誰でも入浴可能になった。また、湯治として知られたこの温泉も今は日帰り入浴を受け入れるなど、時代と共にアップデートを続けている。「入った瞬間、濃さがわかるお湯でした。隣の水風呂と行き来すればサウナに勝るとも劣らない、1日中いたくなる場所でした」とサウナーの夏目も唸るほど。「アタック柔らかでディープな湯感触。優しくて濃い感じは、Cal Tjaderの『Aquarius』を思い出しました」。",
      images: [
        "_MG_4838.jpg",
        "IMG_4917.jpg",
        "_MG_4894.jpg",
        "_MG_4851.jpg",
        "_MG_4901.jpg",
        "_MG_4857.jpg",
        "_MG_4907.jpg",
      ],
    },
    {
      name: "高森田楽保存会",
      category: "食事",
      map: "https://goo.gl/maps/ynjdtR7EU7tEar999",
      spotify: [
        "https://open.spotify.com/embed/track/4JUKPu4JqEeoJPxnRfHEZi?utm_source=generator",
      ],
      content:
        "上色見熊野座神社の隣にある高森田楽保存会は、高森地区の郷土料理・田楽を継承している店の1つで、現在で3代目、2020年に60周年を迎えた。皇族・秋篠宮家から、テレビで活躍する芸能人まで足を運ぶ名店だ。座敷で炭火にあたりながら食事を待つ時間は、まるで実家に帰ってきたかのよう。それぞれの田楽の焼き方を丁寧に教えてくれるが、結局全部自分でやってしまう、面倒見の良すぎるお母さんに、「愛は惜しみなく与えないと！と教えられているようでした」と夏目。「関東のしょっぱめのイメージとは裏腹の優しい味噌の味とそれに負けない素材の旨み。どちらも十分に感じることができました。みんな仕事を楽しんでいたのもよかったです」と振り返る。やけのはら、P-RUFFら4人で構成されるアンビエントユニット・UNKNOWN MEは、この店での経験を想起させる。「アンビエント感覚で楽しめるご飯だったので、こういう曲がいいかなと『Breathing Wave』を選びました。田楽が焼かれるのを見ていると時間の感覚がちょっと変質する感じもありました」。",
      images: [
        "_MG_4991.jpg",
        "_MG_4957.jpg",
        "_MG_4942.jpg",
        "_MG_5007.jpg",
        "_MG_5024.jpg",
      ],
    },
    {
      name: "阿蘇丸漬本舗 徳丸漬物",
      category: "買い物",
      map: "https://goo.gl/maps/oUHro4MXwkz8Arbv7",
      spotify: [
        "https://open.spotify.com/embed/track/12Ud1wrY2Q4yeVQwYAn12X?utm_source=generator",
      ],
      content:
        "高森田楽保存会から市街地へ戻る途中にある徳丸漬物では、3代目を担う夫婦が手作りした漬物を買うことができる。奥さんが自筆で書いているというオシャレなフォントをあしらったラベルと、素材の色を生かしたパッケージが目を引き、ついついお土産に買いたくなる。隣の食堂ではその場で食事もすることができるのだそう。「伝統をしっかりと受け継ぎながら、自分たちの時代のものにしていたのがよかった」と夏目が連想した曲はトクマルシューゴの「Mazume」だ。「ダジャレだけど、聴いてみると漬物に合う音楽でした。日本語が可愛く響いていて、この店の可愛い感じともあってると思います。優しい感じがします」。",
      images: ["_MG_5065.jpg", "_MG_5036.jpg"],
    },
    {
      name: "阿蘇火山博物館",
      category: "博物館",
      map: "https://goo.gl/maps/HdTP9Z8ox3DZU6YT7",
      spotify: [
        "https://open.spotify.com/embed/track/1n5Flv1mYgUhM5TWt6H2FS?utm_source=generator",
      ],
      content:
        "草千里ヶ浜にある1982年に開館した阿蘇火山博物館は、ノスタルジックな雰囲気が今なお残されていて、「昭和の名残り」と「阿蘇のカルデラの全て」を秘めた場所に、博物館好きの夏目のボルテージはピークに達していた。「入り口のレトロなフォントも建物も最高でした。旅の終盤に訪れた場所を振り返りながら、答え合わせのように阿蘇の土地や火山について理解を深めてほしい」と彼は語る。3階の5面スクリーンのあるマルチホールでは、阿蘇の火山やカルデラを説明したショートムービーが多言語で上映されていて、職員の「届けたい」という気持ちが伝わってくる。そして、もう1つ見逃せないのが、特撮のゴジラシリーズを支えた故・井上泰幸氏が手掛けた阿蘇火山のジオラマと、ウルトラマンや映画シン・エヴァンゲリオンの背景美術で有名な島倉二千六氏が担当した、写真と見紛うほどの背景作画だ。突然現れた、カルチャー的な接点に夏目のテンションは急上昇。「昭和の未来感と、マグマの力強さ。そして地球と、丸ごと感じられてスケールが大きい。『火の鳥』を思い出しました」と、Battlesの「Atlas」を選曲。",
      images: [
        "_MG_5101.jpg",
        "_MG_5129.jpg",
        "_MG_5105.jpg",
        "_MG_5082.jpg",
        "_MG_5093.jpg",
      ],
    },
    {
      name: "阿蘇プラザホテル",
      category: "ホテル",
      map: "https://goo.gl/maps/U1Qze9bfQRqGEnKr6",
      spotify: [
        "https://open.spotify.com/embed/track/5s8aZdnosGC0NY1hYzzGYU?utm_source=generator",
      ],
      content:
        "阿蘇プラザホテルは、半世紀以上続く老舗の旅館だ。「温泉ホテルのリラックスしたムードのなかに、絵画やガラス工芸などが並べられていて、美術館の中にいるような気分にもなる」と夏目が語るように、日本画やフランスのガラス作家・エミーレ・ガレの作品が館内に飾ってあるため、浴衣に着替えて大浴場へと向かいながら館内を散策するのも楽しい。\nそんな「ゆるめで不思議な感じの雰囲気」に合わせたいのがロサンゼルスのキーボーディスト・Jacob Mannの「Fiore」だという。ちなみに、最上階の展望風呂は西日がさす夕方がおすすめで、内風呂は朝日を浴びて黄金に輝く湯気とともに入る朝風呂が夏目のお気に入りだ。",
      images: ["_MG_4827.jpg", "_MG_4784.jpg", "_MG_4805.jpg"],
    },
  ],
};

export const placelist3: PlacelistType = {
  id: "bose",
  title: "大人になってもアソびたい",
  artists: ["BOSE（スチャダラパー）"],
  about:
    "『阿蘇ロックフェスティバル』出演のために阿蘇を訪れたことがあるスチャダラパー・Bose。しかし、阿蘇のスポットを巡るのは今回の旅が初めてだった。予想を超える魅力に溢れた阿蘇の場所の数々に、Boseは圧倒される。大人の遊び場は世界有数のカルデラにあった。",
  content:
    "『阿蘇ロックフェスティバル』出演のために阿蘇を訪れたことがあるスチャダラパー・Bose。しかし、阿蘇のスポットを巡るのは今回の旅が初めてだった。予想を超える魅力に溢れた阿蘇の場所の数々に、Boseは圧倒される。大人の遊び場は世界有数のカルデラにあった。",
  places: [
    {
      name: "やま康",
      category: "食事",
      map: "https://goo.gl/maps/NV3KZHxzzxhyUwZJ6",
      spotify: [
        "https://open.spotify.com/embed/track/4QelFzhVgLomeQhvKrwM1S?utm_source=generator",
      ],
      content:
        "オールディーズ好きな店主が経営する高森のあか牛料理専門店。刻んだ大葉がパンチとなったあか牛丼に、Boseは「これは本物。確かにわざわざ食べにきたくなる味」と舌鼓を打つ。確かな品質の赤牛や自家製の漬物の味を堪能できるほか、店内からは雄大な根子岳の景観を目にすることができる。Boseは、やま康のあか牛丼で満たされたあとの余韻を表す音楽としてBobby vintonの「Blue velvet」を選曲。「店主の好きな60'sのヒットソングから」。",
      images: ["_MG_5210.jpg", "_MG_5168.jpg", "_MG_5187.jpg", "_MG_5193.jpg"],
    },
    {
      name: "道の駅あそ望の郷くぎの",
      category: "買い物",
      map: "https://goo.gl/maps/1Wd7dNhiMeGTNX3u8",
      spotify: [
        "https://open.spotify.com/embed/track/2O16qeSdWeec3Kte6TKW9p?utm_source=generator",
      ],
      content:
        "地元の名産品を取り揃えるお土産どころ、レストラン、ドッグラン、さらにはそば道場や温泉を併設する。この場所を訪れた際はちょうど猿回しが行われており、B-BOYな服を身に纏った芸猿のホープ君の軽やかな身のこなしに、Boseも思わず感心。また、地元のかたが拵えた熊本の名産品・いきなり団子を購入し、各生産者ごとのものを食べ比べをする場面も。「同じいきなり団子でも作る人でこんなに味が違うんだ」と地元の味を楽しんだ。実はここに訪れたことがあるというBose。『阿蘇ロックフェスティバル』の前夜祭として、眼前に阿蘇五岳を望む広大な芝生広場のステージに、泉谷しげるとともに立ったという。当時のことを思い出しながら、「この場所でハナレグミの『きみはぼくのともだち』の弾き語りが観られたら最高だなと思いました。満天の星空を観ながら聴きたい」と語る。",
      images: [
        "_MG_5214.jpg",
        "_MG_5239.jpg",
        "_MG_5262.jpg",
        "_MG_5220.jpg",
        "_MG_5285.jpg",
        "_MG_5357.jpg",
      ],
    },
    {
      name: "えびすぱーな 阿蘇店",
      category: "買い物",
      map: "https://goo.gl/maps/zJKMhBUtFvGDgu4v7",
      spotify: [
        "https://open.spotify.com/embed/track/5dw2Dp41BvlB3bWl6uielg?utm_source=generator",
      ],
      content:
        "「暮らしに愛を、食卓に夢を」をコンセプトに掲げる地元密着型のスーパーマーケット。その名の通り、スーパーの看板では恵比寿様が微笑む。店内は店手作りの色鮮やかなポップが目を惹き、陳列される食材に華を添える。「地元の人が毎日使うスーパーマーケットが明るく元気になるように」と、BoseはBobby Caldwellの「Saturday In the Park」を選曲。",
      images: ["bose-aso.jpg"],
    },
    {
      name: "草千里ヶ浜",
      category: "アウトドア",
      map: "https://goo.gl/maps/wPLLkxFZhR6hkjEb8",
      spotify: [
        "https://open.spotify.com/embed/track/7pN8GMLw3prWFn5nvJRM6O?utm_source=generator",
      ],
      content:
        "阿蘇山の火口跡に広がる草原。山々がそびえ立つ雄大な景観は、草千里ヶ浜へ向かう道のりから始まる。どこまでも広がる壮大な光景に「こんな山肌は初めて見ました。まるで異国の地」とBoseは興奮する。Boseが「このあたりの風景を観ながらドライブしてるときに聴きたい」1曲は、William DeVaughnの「Be Thankful For What You Got」だ。",
      images: ["_MG_5340.jpg", "_MG_5357.jpg", "_MG_5346.jpg", "_MG_5358.jpg"],
    },
    {
      name: "吉一牧場",
      category: "アウトドア",
      map: "https://goo.gl/maps/NZ8mRx6982gibTnD8",
      spotify: [
        "https://open.spotify.com/embed/track/6PuIn0KCYvtSpU3kgGsDuA?utm_source=generator",
      ],
      content:
        "草千里ヶ浜から街へと下る道すがら、Boseは放牧牛と出会った。車を走らせているとふと目に入った牧場の牛たちは、驚くほど微動だにしない。突如広がった牧歌的なこの場所に、BoseはThelonious Monk「Sweet And Lovely（Take2）」を選曲する。「全く動かなくて可愛い牛のイメージです」。",
      images: ["_MG_5389.jpg", "_MG_5387.jpg"],
    },
    {
      name: "押戸石の丘",
      category: "アウトドア",
      map: "https://goo.gl/maps/f1Rzt67HyycJLFRy6",
      spotify: [
        "https://open.spotify.com/embed/track/71jnpluqHQp3Y7zHu9vz2X?utm_source=generator",
      ],
      content:
        "阿蘇は南小国町中原、マゼノ渓谷近辺の険しい道のりを往けばそこに広がるのは神秘的な絶景。草原のパノラマ風景を望む火砕流台地の小高い丘には巨石が点在する。先史時代の巨石文化遺跡であることがユネスコ岩石芸術会等で認証されており、ひとつひとつの石が意味を持つ。なかにはシュメール文字が刻まれるとする「鏡石」や方位磁石の針が乱れるほどの磁力を発する「押戸石」があり、パワースポットとしても名高い場所でもある。神秘的な押戸石の丘を表す音楽としてBoseが選んだのは、Matin Dennyの「Hypnotique」。「半信半疑だったけど、登ってみたら催眠にかかったような高揚感がありました。神秘的な場所でも怖さは感じなくて、抜けが良く晴れやかなパワースポットでしたね。風はなく、辺りも静寂に包まれていて、神様に近い場所と言われているのも納得です」。",
      images: [
        "_MG_5472.jpg",
        "_MG_5435.jpg",
        "_MG_5467.jpg",
        "_MG_5469.jpg",
        "_MG_5461.jpg",
        "_MG_5515.jpg",
        "_MG_5504.jpg",
        "_MG_5489.jpg",
      ],
    },
    {
      name: "食のひろ勝",
      category: "食事",
      map: "https://goo.gl/maps/MpRnAx5J9WT64efJ9",
      spotify: [
        "https://open.spotify.com/embed/track/2urwWshyKW7dlNCsf8H005?utm_source=generator",
      ],
      content:
        "阿蘇の夜、Boseは内牧温泉街の一角に佇む日本料理居酒屋「ひろ勝」でひと時を過ごした。ナスの揚げ浸しなどポピュラーな居酒屋メニューから、馬刺しや馬ホルモンの唐揚げといった郷土の味まで、店おすすめの料理の数々を楽しんだ。なかでも醤油と砂糖を絡めて焼いた餅に海苔を巻いた「ぽたぽた焼き」は、シメにぴったりなお腹も心も満たす一品。こんな夜にはAl Greenの「Let's Stay Together」が似合う。「甘いソウルミュージックと地元のお酒、シメはポタポタ焼き」。",
      images: [
        "_MG_5635.jpg",
        "_MG_5587.jpg",
        "_MG_5591.jpg",
        "_MG_5569.jpg",
        "_MG_5584.jpg",
      ],
    },
    {
      name: "大観峰",
      category: "アウトドア",
      map: "https://goo.gl/maps/BxDhj5885UwX7pBU7",
      spotify: [
        "https://open.spotify.com/embed/track/5Xl2WouppBdIMNZonCTR6X?utm_source=generator",
      ],
      content:
        "阿蘇の連峰を望む大観峰は、阿蘇を観光する上で定番となる場所のひとつ。最高峰からの眺望に、Boseは感動する。「流石の絶景に感服しました。気質として、定番すぎて避けてしまいそうな所ですが、例えるなら『やっぱり生で聴く大ヒット曲は凄かった』みたいな。カルデラの全貌が目で見えましたね。自然の大きさと人々の小さな暮らしの対比が見えて、自分のちっぽけさを感じましたね。カルデラの雄大さにスケールの大きなXavier Cugat『Perfidia』を」。",
      images: ["_MG_5673.jpg", "_MG_5661.jpg", "_MG_5667.jpg", "_MG_5652.jpg"],
    },
    {
      name: "千羽鶴鹿公園",
      category: "アウトドア",
      map: "https://goo.gl/maps/5Xnspq9YXRWjSuCb9",
      spotify: [
        "https://open.spotify.com/embed/track/1pDYbRNVr8HmRpfl9z9x5p?utm_source=generator",
      ],
      content:
        "大観峰から黒川温泉街へ向かうやまなみハイウェイに、突如無数のトピアリー（樹木を刈り込んだ造形物）が現れた。鶴やくまモン、人の形を模したものまで、実に多くのトピアリーが立ち並ぶ光景は道ゆく者の目を惹く。加えて鹿、山羊、鶏やうさぎまで居り、それらを突然現れた猫が案内してくれるのだ。「思ったより動物たちと触れ合えて楽しめました。結局なんのための場所だったのか分からなかったのも良かったですね。猫がずっとリードしてくれたのがよかった。かわいい猫が案内してくれるという不思議体験には、坂本慎太郎の『鬼退治』が合いそう」。",
      images: ["_MG_5720.jpg", "_MG_5695.jpg", "_MG_5735.jpg"],
    },
    {
      name: "黒川温泉 お宿 のし湯",
      category: "温泉",
      map: "https://goo.gl/maps/EuWWsbM879EDt5wE7",
      spotify: [
        "https://open.spotify.com/embed/track/0oEIrVWpLj01XtFtDitQyR?utm_source=generator",
      ],
      content:
        "阿蘇の自然を堪能できる露天風呂に、木々に囲まれた静謐な空間が心を癒す「お宿 のし湯」。Boseは日帰り温泉に入浴。「露天風呂、最高でしたね。誰にでもおすすめできる」と太鼓判を押した。そして、回遊廊下や談話室、中庭など館内の情緒ある佇まいは、流れる時間をゆるやかにする。「Bill Evans Trioの『Some Other Time』のような静かなジャズでも聴きながら、ここで家族とゆったりしたい」とBoseは振り返る。",
      images: [
        "_MG_5752.jpg",
        "_MG_5866.jpg",
        "_MG_5750.jpg",
        "_MG_5887.jpg",
        "_MG_5875.jpg",
        "_MG_5823.jpg",
        "_MG_5781.jpg",
        "_MG_5852.jpg",
        "_MG_5835.jpg",
      ],
    },
    {
      name: "そば屋 沙羅",
      category: "食事",
      map: "https://goo.gl/maps/iGQoqWihpzY1fyzE6",
      spotify: [
        "https://open.spotify.com/embed/track/1XttJMNNjyhrdZEqTONgy2?utm_source=generator",
      ],
      content:
        "信州産、阿蘇産や小国産のそば粉を使用した外一そばを提供する「沙羅」。敷地内で採れた野菜やきのこの天ぷらが美味しい天そばを始め、季節限定の鴨せいろそばなどを楽しむことができる。Boseはこの場所を表す音楽にMiyoshi Umekiの「If I give my heart to you」をセレクト。「鴨せいろなのに冷たい蕎麦用のつゆも付いているというサービス精神。変化を恐れない勇気のあるお店には、ハリウッドで初めて活躍した日本人女性のミヨシウメキの歌声が似合います」。",
      images: ["_MG_5920.jpg", "_MG_5907.jpg", "_MG_5894.jpg"],
    },
    {
      name: "OGUNIYA JERSEY",
      category: "買い物",
      map: "https://g.page/ogunijersey?share",
      spotify: [
        "https://open.spotify.com/embed/track/1yPHl365z9tmhXKywwcV2q?utm_source=generator",
      ],
      content:
        "小国町の梅田牧場からその日のうちに直送される牛乳を使用した搾りたて牛乳、ホットミルクやジャージーソフトはここでしか楽しむことができない味。「ノンホモ・ジャージー・低温殺菌」の三拍子揃った牛乳は、口にすれば自然な優しい甘さが広がる。そんなOGUNIYA JERSEYの牛乳を表す1曲にBoseが選んだのはJackie Mittooの「Good Feeling」。「牛乳のまろやかなフィーリングがグッドすぎました」。",
      images: ["_MG_5923.jpg", "_MG_5942.jpg", "_MG_5926.jpg", "_MG_5984.jpg"],
    },
  ],
};

export const placelists: PlacelistType[] = [
  {
    id: "tsuji-imai",
    title: "（アソビ）ギナーズラック",
    artists: ["imai（group_inou）", "辻友貴（cinema staff）"],
    about:
      "初めて阿蘇を訪れたimaiと辻。group_inouとcinema staffとして同時代の音楽シーンを牽引し、長年交流を重ねる彼ら。友人同士だからこそのリラックスした雰囲気のなかで訪れる場所はどこも刺激的。阿蘇ビギナー2人の遊びに満ちた旅は、あまりにも出来すぎていた。",
    content:
      "初めて阿蘇を訪れたimaiと辻。group_inouとcinema staffとして同時代の音楽シーンを牽引し、長年交流を重ねる彼ら。友人同士だからこそのリラックスした雰囲気のなかで訪れる場所はどこも刺激的。阿蘇ビギナー2人の遊びに満ちた旅は、あまりにも出来すぎていた。",
    places: [
      {
        name: "香辛喫茶 Lion Curry",
        category: "食事",
        map: "https://goo.gl/maps/hZhvcMQTcQiMWaJB8",
        spotify: [
          "https://open.spotify.com/embed/track/4C8GVfHtHKftmM9NVzfIqB?utm_source=generator",
          "https://open.spotify.com/embed/track/3fPhSGnlSorRpDhIui8bfZ?utm_source=generator",
        ],
        content:
          "阿蘇に到着した2人が最初に訪れた場所は、バンドマンだった店主が経営するスパイスカレー屋。店名の「Lion」は、店主が組んでいたバンド名が由来だという。無類の酒好きの辻に「酒に合う」と言わしめたスパイスカレーは、列をなすほど地元でも人気の味。imaiも「音楽家の作るカレーはなんでこうも美味しいのでしょうか？誰か僕の代わりに研究して下さい！」とその味を堪能し、「ウミネコサウンズのおさむさんもミュージシャンでカレー屋さん」と、この場所に紐づく音楽としてウミネコサウンズの「春はまだかい」を選曲。辻は、この店を紹介してくれた熊本発のバンド、Shikiの「Venom」を選んだ。「紹介してくれたバンドShikiのメンバー杉本さんに愛を込めて」。",
        images: ["_MG_3510.jpg", "_MG_3505.jpg", "_MG_3474.jpg"],
      },
      {
        name: "そらふねの桟橋",
        category: "アウトドア",
        map: "https://goo.gl/maps/t9vmDUzYrgUa63XAA",
        spotify: [
          "https://open.spotify.com/embed/track/2nFRaREPvleyRg1ABMT4pd?utm_source=generator",
          "https://open.spotify.com/embed/track/5v5ljtsZJY7KhCanQGsneK?utm_source=generator",
        ],
        content:
          "「Lion Curry」で腹を満たしたあとは、身体を動かして大自然を堪能したい。「そらふねの桟橋 」は田子展望所の山道を約10分歩いた先にある。桟橋からのパノラマ風景はもちろんのこと、辿り着くまでの山景も必見。そよともしない静まり返った山あいでは、思わずやまびこを聴きたくなる。「『やっほー！』のやまびこがあまりにも美しいディレイで感動しました。いきなり青春しちゃったなー。金色の草がキラキラしていて、頭の中ではTeenage Fanclubの『Going Places』が流れていました」とimai。辻は「澄んだ空気、綺麗な風景を見ると、美しいアンビエントミュージックを聴きたくなりますね」と Hammockの「God Send Us a Signal」を選曲した。さらに、阿蘇の雄大さを早速体感したimaiは、自身にとっての自然の存在について言及する。「コロナ禍でみんながストレスを抱えて対立や強い意見が散見されるなかで、自然を感じられる場所に何度か訪れて気分転換していました。MONO NO AWAREの「そこにあったから」でも歌われているように、人間と違って自然はただそこにあるだけで、何も返ってこない。だからこそ救われます」。 ",
        images: ["_MG_3578.jpg", "_MG_3521.jpg", "_MG_3525.jpg"],
      },
      {
        name: "鍋ヶ滝",
        category: "アウトドア",
        map: "https://goo.gl/maps/ELguHimQGwKksUcY7",
        spotify: [
          "https://open.spotify.com/embed/track/0FpZLGAuVUKGpxGreWtWTm?utm_source=generator",
          "https://open.spotify.com/embed/track/59y8j9XS7rnXXmub1TvQUf?utm_source=generator",
        ],
        content:
          "滝を裏側から見たことはあるだろうか。鍋ヶ滝は滝壺の奥で流れ落ちる水を眺めることができる、いわゆる「裏見の滝」。木漏れ日が差し込む滝壺は、imaiに爽快感と癒しを与える。「Melt-Bananaの『Circle Jack』のような極度に激しい音楽を聴くと爽快感を覚えるのですが、鍋ヶ滝もそんな感じでした。一周回って癒し系！」。一方辻は、鍋ヶ滝を「つまみになる景色」と表現。imaiも「大自然のなかって最高だよね」と呼応する。酒を嗜みたくなるほどの光景に、辻は「あのすごい自然を目の前に、『自分生きてるなぁ』って感じてる時に聴きたくなる曲です」とeastern youthの「ソンゲントジユウ 」を紐付ける。",
        images: [
          "_MG_3659.jpg",
          "_MG_3633.jpg",
          "_MG_3663.jpg",
          "_MG_3628.jpg",
        ],
      },
      {
        name: "OGUNIYA JERSEY",
        category: "買い物",
        map: "https://g.page/ogunijersey?share",
        spotify: [
          "https://open.spotify.com/embed/track/4gD68gReo8iXcV9FeRTyQL?utm_source=generator",
          "https://open.spotify.com/embed/track/7hzgk557YLr0722EFkmp9Z?utm_source=generator",
        ],
        content:
          "阿蘇では自然だけでなく、雄大な土地が生み出した牛乳も味わいたい。鍋ヶ滝から車で約10分、ふらりと立ち寄った道の駅小国内のジャージーソフト屋「 OGUNIYA JERSEY」のジャージーソフトと牛乳の濃厚で優しい味わいに、imaiと辻は感動を覚える。「milkと言ったらこのバンドのことを思い出します」と、Neutral Milk Hotel 「Two-Headed Boy」を選んだ辻は、「牛乳でこんなに感動したことないです」と言う。ジャージーソフトに加えて、搾りたての冷たい牛乳とホットミルクも絶対に味わうべき一品だ。特にホットミルクが気に入ったimaiは、「ホットミルクのシルキーな口当たりはディアンジェロのグルーヴでした。ソフトクリームに行きがちだけど、ホットミルクもマストで！」と振り返った。",
        images: ["_MG_3733.jpg", "_MG_3700.jpg", "_MG_3691.jpg"],
      },
      {
        name: "河津酒造",
        category: "酒造",
        map: "https://goo.gl/maps/Kgbqz8rpkJpD1UKM7",
        spotify: [
          "https://open.spotify.com/embed/track/4gD68gReo8iXcV9FeRTyQL?utm_source=generator",
          "https://open.spotify.com/embed/track/3DTRil2jPOSKRVazEToelS?utm_source=generator",
        ],
        content:
          "「OGUNIYA JERSEY」と同じく、道の駅小国に店舗を構える「河津酒造」が気になり、imaiと辻は近くにある酒蔵を見学させてもらえることに。東京のIT企業で勤務したのち、2011年に3代目として酒蔵を継いだ現当主から話を聞いた。当主が話す河津酒造のこだわりに、2人は音楽と日本酒づくりを重ね合わせる。この場所を表す音楽にRei Harakamiの「Grief & Loss」を選んだimaiは、「『敢えて古い機械や手法を使う』という『効率/非効率』の話をされていたのですが、やっぱり一台の機材を使い倒していたハラカミさんが浮かびます。ハラカミさんもお酒が大好きでしたよね」と語る。辻も同じくものづくりのスタイルに感銘を受け、旅の車内で流れた往年のバンドの楽曲を選ぶ。「昔から活動し続けてその時代の音や録音技術も大切にしつつ、モダンな流れも入れていく感じがFoo Fightersを想起させます。車内ラジオで流れていたので彼らの『Shame Shame』を」。日本酒の多様性が強まる今、「100年後まで誰かが乾杯してくれるお酒」を作り続けていくために、酒造の強みを生かす「非効率」と、より良い品質を目指す「効率」を同居させることを重視する河津酒造。そのスタイルにより生み出した甘口の日本酒「純米吟醸 花雪」は、「純米酒大賞2016純米吟醸酒部門金賞」を受賞した。",
        images: ["_MG_3837.jpg", "_MG_3767.jpg", "_MG_3910.jpg"],
      },
      {
        name: "扇",
        category: "食事",
        map: "https://goo.gl/maps/mmheZBofXgQ2M5NUA",
        spotify: [
          "https://open.spotify.com/embed/track/5tP1KB1MxwlhqGNlFQMXMc?utm_source=generator",
          "https://open.spotify.com/embed/track/1f82gDcHIxzuT3yEawY5GE?utm_source=generator",
        ],
        content:
          "辻の居酒屋に対する鋭い嗅覚で、「これぞまさに居酒屋」と言うべき店に出会った。それが内牧の「阿蘇プラザホテル」向かいに佇む居酒屋「扇」。レーサーとしても活躍するタレントの近藤真彦も訪れる場所だ。割烹着を身に纏った日本酒好きの女将が1人で切り盛りし、天草の燻製かまぼこや馬のアキレス腱を煮込んだおでんの湯気が立ち上る店内では、ムーディーな昭和歌謡が響き渡る。美川憲一の「さそり座の女」が流れ、imaiは「M-1でモグライダーがネタにしていたこの曲がかかった瞬間ぶちあがりました。80歳のお母さんが一人で切り盛りしている最高のお店」と気持ちが昂る。酒がすすむ情緒溢れる雰囲気で、imaiと辻の話にも花が咲く。「こういう最高な居酒屋だと話が弾むわけで。imaiさんと音楽のこと語り合えた感じが堪らないってことで、imaiさんの『Alone 』を選びました」。",
        images: [
          "_MG_4002.jpg",
          "_MG_3997.jpg",
          "_MG_3993.jpg",
          "_MG_3952.jpg",
        ],
      },
      {
        name: "阿蘇神社",
        category: "神社",
        map: "https://goo.gl/maps/7KD4s7XnRE6nHZoz9",
        spotify: [
          "https://open.spotify.com/embed/track/2HbDLvUR0SA1o9BDMAqqNM?utm_source=generator",
          "https://open.spotify.com/embed/track/3YQ7hYxZ2w2tVvla6yAuy3?utm_source=generator",
        ],
        content:
          "阿蘇市一の宮町の「阿蘇神社」は、全国に約500社ある「阿蘇神社」の総本社。現在は熊本地震による被害からの復旧工事を行っている。「神秘的なものを感じると聴きたくなる音楽です」と、辻はJulien Baker、 Phoebe BridgersとLucy Dacusの3人によるBoygeniusの楽曲「Ketchum.ID」をこの場所に紐付けた。社殿を参観したのち、2人は十種類の縁起物のいずれかが入った「幸福おみくじ」をひいた。imaiは延命長寿や金運招来を表す亀のお守りが納められたものをひき当て、お守りの可愛さに喜ぶ。「おみくじに付いてくる金の小さなカメが可愛かったので、PAS TASTAの『turtle thief』を」。",
        images: ["_MG_4036.jpg"],
      },
      {
        name: "手打ちそば 日出や",
        category: "食事",
        map: "https://goo.gl/maps/9RRtRYJPYzcsKsbk6",
        spotify: [
          "https://open.spotify.com/embed/track/3svnJmqz5Ol2Ba14zevaCn?utm_source=generator",
          "https://open.spotify.com/embed/track/2OXOhWojqfEcPxTDN9C0iE?utm_source=generator",
        ],
        content:
          "南阿蘇久木野産の蕎麦粉を石臼で自家製粉したそばを提供する「日出や」。阿蘇産の自然薯を使用したとろろそばを味わった2人。その味もさることながら、店内に置かれたバスドラムやコンガにも目を向けたい。レゲエやインド音楽好きの店主は、以前レゲエバンドをやっていたという。熊本地震により被害を受ける以前はドラムセットが店内にあり、友人であるLITTLE TEMPOのメンバーを招いたスティールパン教室や音楽ライブを開催していた。それを聞いた2人は興奮。辻はLITTLE TEMPOの「Over the rainbow」を、imaiはキセルの「ハナレバナレ」を選曲。「店長さんがLITTLE TEMPOとお知り合いとの事で、店内ではキセルが流れていました。キセルが大好きで、『新宿時代のリキッドルームに観に行ったな』とか思い出しました。LITTLE TEMPOの内田直之さんがミックスされているアルバムから1曲」。",
        images: [
          "_MG_4069.jpg",
          "_MG_4068.jpg",
          "_MG_4061.jpg",
          "_MG_4058.jpg",
        ],
      },
      {
        name: "高森湧水トンネル公園",
        category: "アウトドア",
        map: "https://goo.gl/maps/17FeQYw72svRs3Xi6",
        spotify: [
          "https://open.spotify.com/embed/track/2mlIzqDE7RaMaMx1UPdsXL?utm_source=generator",
          "https://open.spotify.com/embed/track/2QP3GjOPJkwxt7apCmw2BA?utm_source=generator",
        ],
        content:
          '鉄道建設のために掘削していた岩盤の跡地にできたトンネル公園内には2055mにわたる水路が続く。地元の小中学生手作りの作品、イルミネーションやオブジェを目にしながら水路沿いの歩道を進むと、最後に行き着くのは仕掛け噴水「ウォーターパール」。小さな頃から水が好きだったimaiは、ストロボの光により不思議な動きをする水玉に、「チープで幻想的な照明や謎のオブジェで笑っていると、最後に"ウォーターパール"でカマされる感じはCeephax Acid Crewの『Essex Remblance』を連想しました。最後まで油断するなよ！」と大興奮。身を乗り出してウォーターパールの正体を解明しようとしていた辻は「絶妙なB級感とワクワクするサイケ感」と、トンネル公園の雰囲気にThe Flaming Lipsの「The Yeah Yeah Yeah Song」を重ね合わせる。',
        images: ["_MG_4134.jpg", "_MG_4127.jpg", "_MG_4103.jpg"],
      },
      {
        name: "草千里ヶ浜",
        category: "アウトドア",
        map: "https://goo.gl/maps/wPLLkxFZhR6hkjEb8",
        spotify: [
          "https://open.spotify.com/embed/track/48UPSzbZjgc449aqz8bxox?utm_source=generator",
          "https://open.spotify.com/embed/track/3uZDobGcvgPNlR5mXCYv5w?utm_source=generator",
        ],
        content:
          "まだ雪解け前の草千里ヶ浜を訪れた2人。広大な土地に異国の雰囲気を感じた辻は「なんとなくこの曲が思い浮かびました 」とRed Hot Chili Peppers「Californication」を挙げる。よく国内の自然を感じに行くimaiだが、「とても日本とは思えない壮大な景色！そりゃあ心も浄化されますよ。久々にこんな規模の自然を感じました」と草千里ヶ浜の景色に圧倒された。自然と同様、コロナ禍でimaiの心を救ったのは音楽。「コロナでどこも行けなかった時は、リョウコ2000の『Humming Bird』や、パソコン音楽クラブのアルバム『See-Voice』のような音楽に救われました」。",
        images: ["_MG_4275.jpg", "_MG_4269.jpg"],
      },
      {
        name: "おべんとうのヒライ阿蘇立野店",
        category: "買い物",
        map: "https://goo.gl/maps/SE3jYHbsKoCks5S28",
        spotify: [
          "https://open.spotify.com/embed/track/5XtZpzK2QfBCRG93IQznkW?utm_source=generator",
          "https://open.spotify.com/embed/track/176UHHdZMkujwcQdDT7xgn?utm_source=generator",
        ],
        content:
          '阿蘇を巡る旅の最後に訪れたのは熊本発の惣菜・弁当ショップ「ヒライ」の阿蘇立野店 。地域に根ざし、人々の生活に寄り添うヒライが生み出した「ちくわサラダ」は、いまや熊本定番の料理。ちくわサラダをはじめとする惣菜や弁当、イートインメニューの多彩なラインナップに、辻とimaiも思わずたじろぐ。辻は「今のトレンドも抑えたあのカオスな品揃え、モダンなプログレでしょう」と、ヒライをblack midiの「John Limai」になぞらえた。一方imaiはヒライへのリベンジを誓う。「俺たちの終着駅"ヒライ"！存在が大きすぎてとても一回では把握する事が出来ませんでした。帰り道にすごい夕陽が出ていて、横沢俊一郎の『プロローグ』で歌われる＜エンドロールから 始まる打ち上げ花火＞という一節が浮かびました。また来ます！！！」。',
        images: ["_MG_4316.jpg", "_MG_4300.jpg", "_MG_4299.jpg"],
      },
      {
        name: "高森駅",
        category: "アウトドア",
        map: "https://goo.gl/maps/YjTFHwsH5hRe8ujC9",
        spotify: [
          "https://open.spotify.com/embed/track/0dcL4iqX2uzYMPzUM5tj2k?utm_source=generator",
          "https://open.spotify.com/embed/track/5QAEo7jpRrrHuo3mMrw0gh?utm_source=generator",
        ],
        content:
          "高森湧水トンネル公園の駐車場で南阿蘇鉄道のトロッコ列車の看板を見つけたimaiと辻は、列車に乗るべく高森駅へと向かう。駅舎内に掲示された、熊本地震からの復興を応援する漫画家・原作者117名のメッセージを見てひとしきり感動したのち、2人は電車に乗車。赤い車体に、辻はくるりの「赤い電車 」を連想する。2人を乗せた貸し切りの電車は、車窓からの眺めを解説する車掌のトークとともに、現在運行する区間の終点「中松駅」を目指す。車掌のテンポの良いトークは必聴。「電車に乗る事も気を遣うような時代に、まさかの貸し切りでついついはしゃいでしまいました。車掌さんのアナウンスもジャングルクルーズ感があって良い。心が少年に戻ったので、あの頃大好きだったこの曲を」とimaiはスピッツの「グラスホッパー」を選ぶ。",
        images: [
          "_MG_4251.jpg",
          "_MG_4244.jpg",
          "_MG_4224.jpg",
          "_MG_4217.jpg",
          "_MG_4209.jpg",
          "_MG_4201.jpg",
          "_MG_4197.jpg",
          "_MG_4142.jpg",
        ],
      },
    ],
  },
  {
    id: "natsumetomoyuki",
    title: "愛は資本主義じゃない",
    artists: ["夏目知幸"],
    about:
      "長い歴史をかけて形成された阿蘇のカルデラは、埋立地の千葉県浦安市で生まれ育った夏目知幸の知的好奇心を刺激する。高く透き通った阿蘇の空に比例するように、明るくて暖かい街の人たち。初めてなのにどこか暖かい、そんな阿蘇の魅力を伝えるプレイスリスト。",
    content:
      "30万年程前に数回起きたとされる噴火によって形成された阿蘇のカルデラ地形。想像も及ばないスケールの時間の流れは、千葉県浦安市で生まれ育った夏目知幸の知的好奇心を刺激する。「浦安の埋立地エリアは高低差がないフラットな土地。人工的に作られた街なので、神社仏閣もありません。真逆と言っていい阿蘇にはとても興味を引かれます」。山以外に遮るものがなく、高く透き通った阿蘇の空に比例するように、明るくて暖かい街の人たち。初めてなのにどこか暖かい、そんな阿蘇の魅力を伝えるプレイスリスト。夏目が阿蘇で出会ったのは、面倒見が良すぎるほどの店の人々と見飽きることのない大自然。愛はおしゃれでもなければ、対価を払うものでもない。決められた枠組みや画面のなかでの生活に疲れたら訪れたい阿蘇の場所。",
    places: [
      {
        name: "父娘庵",
        category: "食事",
        map: "https://g.page/oyakoan?share",
        spotify: [
          "https://open.spotify.com/embed/track/6gB7OjDWIQSR7uzwHYxAO9?utm_source=generator",
        ],
        content:
          "住宅街にひっそりと構える父娘庵（おやこあん）は、ハンバーグ定食や阿蘇産の黒毛和牛を使ったステーキセットなどが味わえる定食屋で、いつも多くの地元のお客さんで賑わっている。料理人として修行を積んだ店主が「亡くなった娘と一緒に店を出す」という長年の夢を実現させたのがこの店で2017年のオープン以来、様々なお客さんをもてなしてきた。亡き娘の描いた絵が店の至るところに飾ってあり、東京で歌手として活動する息子・水瀬団が店の広報担当で、家族一丸となって今日も営業している。「愛に溢れていてまるで実家のよう」と夏目が語る店の雰囲気は、お母さんにご飯のおかわりを頼むついでに、身の上話もしたくなってしまうような温かさがある。店主いわく「事前に相談してもらえれば、離乳食から貸切営業まで対応可能」とのことで、これまでリクエストされたメニューの数だけ、訪れた人のドラマがあった。夏目が選曲したのは、1970年代に活躍したブラジルの歌手・Toni Tornadoの「Cabeca Oca」。「楽しいお店だったので、楽しい曲を。旅の最初にノリよく行きたい感じにぴったりの曲です」。",
        images: ["_MG_4391.jpg", "_MG_4376.jpg", "_MG_4379.jpg"],
      },
      {
        name: "上色見熊野座神社",
        category: "神社",
        map: "https://goo.gl/maps/QGmS1rfX97zMFujp6",
        spotify: [
          "https://open.spotify.com/embed/track/4QNQYh76GRt6L3asf6LZlo?utm_source=generator",
        ],
        content:
          "上色見熊野座神社は、阿蘇・高森町にある四大熊野座神社の1つで、国産みの神である伊邪那岐命（イザナギノミコト）、伊邪那美命（イザナミノミコト）を祀っている。両側に広がる背の高い杉林に日の光を遮られた参道を1歩ずつ上がるたび、静寂でひんやりとした空気が鮮明になり、「神域さ」を感じる場所だ。「ゾーンが変わるような感じがとてもよかったです」と夏目。「『結界を知らせるための神社は境内の道をまっすぐには作らないことがある』と、以前聞いたことを思い出すような、緩やかなカーブがかかった本殿へのアプローチ。何かに誘われている感覚があってワクワクしました。」。参拝をすませたら、神社の奥にある10メートルほどの穴が空いた「穿戸岩（うげといわ）」も見逃せない。夏目いわく、「光の差し方や風の抜け方がとてもよくて、祈りたくなるような雰囲気を感じました」。選曲は、Luiz Bonfa の「Enchanted Mirror」。「神秘的な場所で、ゲームをよくやる僕にとってはRPGゲームの重要な場所のようにも感じました。優しい感じもあったので、こういう曲が合うと思います」。",
        images: ["_MG_4418.jpg", "_MG_4411.jpg", "_MG_4427.jpg"],
      },
      {
        name: "白川水源",
        category: "アウトドア",
        map: "https://goo.gl/maps/S6ULcLAkHuEFGm9LA",
        spotify: [
          "https://open.spotify.com/embed/track/5wSagCWflNwJ1xM59ZKw6O?utm_source=generator",
        ],
        content:
          "「火の国・熊本とはいえ、水源もたくさんあって、土地がいきいきとしているのがとても印象的でした」と語る夏目が訪れたのは白川水源。60トンもの水が毎分湧き出ていて、熊本市内を流れる白川の源にもなっている、阿蘇を代表する水源だ。水面に映る木々の反射は、鏡を見ているように美しく、水の透明度も目を見張るほど。街の至るところにも、他の多くの水源を見ることができる阿蘇は、歩いているだけで「自然の循環」を体感できる。「まず溶岩があって、そこに水が流れて水源が多くできたんだろうなと、大地や山のことについて考えてしまう。阿蘇はとにかくスケールが大きい場所だなと思います」と夏目。そんな白川水源には、ブラジルのオルタナティブロックバンドの曲「Sorbe o Tempo」をセレクト。「すごく瑞々しいのが好きでたまに聞く彼らのヒット曲です。軽くて、自然。ちょっと青春っぽい匂いがする曲を」。",
        images: [
          "_MG_4464.jpg",
          "_MG_4488.jpg",
          "_MG_4481.jpg",
          "_MG_4502.jpg",
        ],
      },
      {
        name: "火の山トンネル",
        category: "アウトドア",
        map: "https://goo.gl/maps/1v9aF1nr6Vi2enmu7",
        spotify: [
          "https://open.spotify.com/embed/track/6658u0EPu6u0x9r5A4qT4h?utm_source=generator",
        ],
        content:
          "阿蘇パノラマラインから阿蘇山頂に向かう途中に位置する火の山トンネル一帯は、どれだけ近づいても見上げずにはいられない、雄大な山の峰が連なっている。「トンネルが異世界へと続くエントランスみたいで、冒険心をくすぐられるような高揚感が楽しかった」と夏目が語るように、トンネルを抜けると見えてくるのは、どこまでも続く草原や噴火したばかりの阿蘇山から延々と溢れ出る煙だ。「ニュースでみた噴火の映像を思い出しました」。目の前に広がる大自然に圧倒され、「今噴火したら終わるな」という自然への畏怖の念をも感じてしまう。「スケールの大きい景色に合う音楽を考えてたら、意外とこういう曲かも」と、夏目はKhotinの「Groove 32」をセレクト。",
        images: [
          "_MG_4526.jpg",
          "_MG_4571.jpg",
          "_MG_4544.jpg",
          "_MG_4605.jpg",
        ],
      },
      {
        name: "大観峰",
        category: "アウトドア",
        map: "https://goo.gl/maps/BxDhj5885UwX7pBU7",
        spotify: [
          "https://open.spotify.com/embed/track/4CeeEOM32jQcH3eN9Q2dGj?utm_source=generator",
        ],
        content:
          "大観峰は、阿蘇の山々を360度見渡す限り楽しめる絶景スポットだ。阿蘇を訪れたら必ず立ち寄りたい。「あまりない地形に立たされている感じがした」と夏目。夕暮れ時は、自然が作り出したとは思えない、綺麗な紫や青が混じったパステルカラーが、山際をなぞるように広がり幻想的な景色を味わうことができる。また、ここから見える阿蘇五岳はお釈迦様の寝姿に見えることから「涅槃像」とも呼ばれていて、お坊さんからの信仰もあるのだそう。\n「大観峰から見える阿蘇山＝涅槃像。英語で涅槃仏を『リクライニング・ブッダ』というのはちょっと違うような気もしますが、涅槃といえばNirvana。そして、10代か20代前半の若い男の子たちがはしゃいでいたり、隣県ナンバーの車で訪れた若い子たちも楽しそうにしてたので、もうこの曲しかないだろうと思います」と夏目。Nirvanaの「 Smells like Teen spirit」を、箸が転んでもおかしい世代と阿蘇の涅槃にむけて選曲。",
        images: ["_MG_4651.jpg", "_MG_4626.jpg", "_MG_4659.jpg"],
      },
      {
        name: "酒房 筍ん子",
        category: "食事",
        map: "https://goo.gl/maps/drex3Feu2Tcj1dx88",
        spotify: [
          "https://open.spotify.com/embed/track/4rB8ebMrJRYoWCyyWqs585?utm_source=generator",
        ],
        content:
          "「提灯をすぎて、奥まった細い道を突き当たったとこにある引き戸、という店までのアプローチからよかった」と振り返るのは、地酒と郷土料理が味わうことができる居酒屋・酒房 筍ん子。家族で経営しているこの店は、料理も雰囲気も暖かみを感じることのできる店だ。「女将さんの日本酒の説明もすごく丁寧で、昼間に行った水源で感じた水の柔らかさを再確認できました。1日阿蘇を巡った体験がお酒として抽出され、味わえたのもとてもよかったです」と夏目。「からし蓮根などの地元のものはもちろん、自家製ソースのナポリタンも最高でした」。選んだ曲は、阿久悠の作詞で1974年リリースされた伊藤咲子の「ひまわり娘」。「昭和っぽい感じからこの曲にしました。イントロがThe Rolling Stonesの『Ruby Tuesday』みたいで洒落てるんです」。",
        images: [
          "_MG_4679.jpg",
          "_MG_4759.jpg",
          "_MG_4672.jpg",
          "_MG_4768.jpg",
        ],
      },
      {
        name: "地獄温泉 すずめの湯",
        category: "温泉",
        map: "https://goo.gl/maps/eyahD8gGVhQj4tK99",
        spotify: [
          "https://open.spotify.com/embed/track/53xtrYKwCtkjxgRrDA8vgg?utm_source=generator",
        ],
        content:
          "地獄温泉は200年以上の歴史を持つ阿蘇の名湯だ。2016年の熊本地震で館内の大部分が被害を受けるも、残った部分を中心に復興を開始。震災以前は混浴だったすずめの湯は、復興を機に着衣入浴で性別、性自認にかかわらずいつでも誰でも入浴可能になった。また、湯治として知られたこの温泉も今は日帰り入浴を受け入れるなど、時代と共にアップデートを続けている。「入った瞬間、濃さがわかるお湯でした。隣の水風呂と行き来すればサウナに勝るとも劣らない、1日中いたくなる場所でした」とサウナーの夏目も唸るほど。「アタック柔らかでディープな湯感触。優しくて濃い感じは、Cal Tjaderの『Aquarius』を思い出しました」。",
        images: [
          "_MG_4838.jpg",
          "IMG_4917.jpg",
          "_MG_4894.jpg",
          "_MG_4851.jpg",
          "_MG_4901.jpg",
          "_MG_4857.jpg",
          "_MG_4907.jpg",
        ],
      },
      {
        name: "高森田楽保存会",
        category: "食事",
        map: "https://goo.gl/maps/ynjdtR7EU7tEar999",
        spotify: [
          "https://open.spotify.com/embed/track/4JUKPu4JqEeoJPxnRfHEZi?utm_source=generator",
        ],
        content:
          "上色見熊野座神社の隣にある高森田楽保存会は、高森地区の郷土料理・田楽を継承している店の1つで、現在で3代目、2020年に60周年を迎えた。皇族・秋篠宮家から、テレビで活躍する芸能人まで足を運ぶ名店だ。座敷で炭火にあたりながら食事を待つ時間は、まるで実家に帰ってきたかのよう。それぞれの田楽の焼き方を丁寧に教えてくれるが、結局全部自分でやってしまう、面倒見の良すぎるお母さんに、「愛は惜しみなく与えないと！と教えられているようでした」と夏目。「関東のしょっぱめのイメージとは裏腹の優しい味噌の味とそれに負けない素材の旨み。どちらも十分に感じることができました。みんな仕事を楽しんでいたのもよかったです」と振り返る。やけのはら、P-RUFFら4人で構成されるアンビエントユニット・UNKNOWN MEは、この店での経験を想起させる。「アンビエント感覚で楽しめるご飯だったので、こういう曲がいいかなと『Breathing Wave』を選びました。田楽が焼かれるのを見ていると時間の感覚がちょっと変質する感じもありました」。",
        images: [
          "_MG_4991.jpg",
          "_MG_4957.jpg",
          "_MG_4942.jpg",
          "_MG_5007.jpg",
          "_MG_5024.jpg",
        ],
      },
      {
        name: "阿蘇丸漬本舗 徳丸漬物",
        category: "買い物",
        map: "https://goo.gl/maps/oUHro4MXwkz8Arbv7",
        spotify: [
          "https://open.spotify.com/embed/track/12Ud1wrY2Q4yeVQwYAn12X?utm_source=generator",
        ],
        content:
          "高森田楽保存会から市街地へ戻る途中にある徳丸漬物では、3代目を担う夫婦が手作りした漬物を買うことができる。奥さんが自筆で書いているというオシャレなフォントをあしらったラベルと、素材の色を生かしたパッケージが目を引き、ついついお土産に買いたくなる。隣の食堂ではその場で食事もすることができるのだそう。「伝統をしっかりと受け継ぎながら、自分たちの時代のものにしていたのがよかった」と夏目が連想した曲はトクマルシューゴの「Mazume」だ。「ダジャレだけど、聴いてみると漬物に合う音楽でした。日本語が可愛く響いていて、この店の可愛い感じともあってると思います。優しい感じがします」。",
        images: ["_MG_5065.jpg", "_MG_5036.jpg"],
      },
      {
        name: "阿蘇火山博物館",
        category: "博物館",
        map: "https://goo.gl/maps/HdTP9Z8ox3DZU6YT7",
        spotify: [
          "https://open.spotify.com/embed/track/1n5Flv1mYgUhM5TWt6H2FS?utm_source=generator",
        ],
        content:
          "草千里ヶ浜にある1982年に開館した阿蘇火山博物館は、ノスタルジックな雰囲気が今なお残されていて、「昭和の名残り」と「阿蘇のカルデラの全て」を秘めた場所に、博物館好きの夏目のボルテージはピークに達していた。「入り口のレトロなフォントも建物も最高でした。旅の終盤に訪れた場所を振り返りながら、答え合わせのように阿蘇の土地や火山について理解を深めてほしい」と彼は語る。3階の5面スクリーンのあるマルチホールでは、阿蘇の火山やカルデラを説明したショートムービーが多言語で上映されていて、職員の「届けたい」という気持ちが伝わってくる。そして、もう1つ見逃せないのが、特撮のゴジラシリーズを支えた故・井上泰幸氏が手掛けた阿蘇火山のジオラマと、ウルトラマンや映画シン・エヴァンゲリオンの背景美術で有名な島倉二千六氏が担当した、写真と見紛うほどの背景作画だ。突然現れた、カルチャー的な接点に夏目のテンションは急上昇。「昭和の未来感と、マグマの力強さ。そして地球と、丸ごと感じられてスケールが大きい。『火の鳥』を思い出しました」と、Battlesの「Atlas」を選曲。",
        images: [
          "_MG_5101.jpg",
          "_MG_5129.jpg",
          "_MG_5105.jpg",
          "_MG_5082.jpg",
          "_MG_5093.jpg",
        ],
      },
      {
        name: "阿蘇プラザホテル",
        category: "ホテル",
        map: "https://goo.gl/maps/U1Qze9bfQRqGEnKr6",
        spotify: [
          "https://open.spotify.com/embed/track/5s8aZdnosGC0NY1hYzzGYU?utm_source=generator",
        ],
        content:
          "阿蘇プラザホテルは、半世紀以上続く老舗の旅館だ。「温泉ホテルのリラックスしたムードのなかに、絵画やガラス工芸などが並べられていて、美術館の中にいるような気分にもなる」と夏目が語るように、日本画やフランスのガラス作家・エミーレ・ガレの作品が館内に飾ってあるため、浴衣に着替えて大浴場へと向かいながら館内を散策するのも楽しい。\nそんな「ゆるめで不思議な感じの雰囲気」に合わせたいのがロサンゼルスのキーボーディスト・Jacob Mannの「Fiore」だという。ちなみに、最上階の展望風呂は西日がさす夕方がおすすめで、内風呂は朝日を浴びて黄金に輝く湯気とともに入る朝風呂が夏目のお気に入りだ。",
        images: ["_MG_4827.jpg", "_MG_4784.jpg", "_MG_4805.jpg"],
      },
    ],
  },
  {
    id: "bose",
    title: "大人になってもアソびたい",
    artists: ["BOSE（スチャダラパー）"],
    about:
      "『阿蘇ロックフェスティバル』出演のために阿蘇を訪れたことがあるスチャダラパー・Bose。しかし、阿蘇のスポットを巡るのは今回の旅が初めてだった。予想を超える魅力に溢れた阿蘇の場所の数々に、Boseは圧倒される。大人の遊び場は世界有数のカルデラにあった。",
    content:
      "『阿蘇ロックフェスティバル』出演のために阿蘇を訪れたことがあるスチャダラパー・Bose。しかし、阿蘇のスポットを巡るのは今回の旅が初めてだった。予想を超える魅力に溢れた阿蘇の場所の数々に、Boseは圧倒される。大人の遊び場は世界有数のカルデラにあった。",
    places: [
      {
        name: "やま康",
        category: "食事",
        map: "https://goo.gl/maps/NV3KZHxzzxhyUwZJ6",
        spotify: [
          "https://open.spotify.com/embed/track/4QelFzhVgLomeQhvKrwM1S?utm_source=generator",
        ],
        content:
          "オールディーズ好きな店主が経営する高森のあか牛料理専門店。刻んだ大葉がパンチとなったあか牛丼に、Boseは「これは本物。確かにわざわざ食べにきたくなる味」と舌鼓を打つ。確かな品質の赤牛や自家製の漬物の味を堪能できるほか、店内からは雄大な根子岳の景観を目にすることができる。Boseは、やま康のあか牛丼で満たされたあとの余韻を表す音楽としてBobby vintonの「Blue velvet」を選曲。「店主の好きな60'sのヒットソングから」。",
        images: [
          "_MG_5210.jpg",
          "_MG_5168.jpg",
          "_MG_5187.jpg",
          "_MG_5193.jpg",
        ],
      },
      {
        name: "道の駅あそ望の郷くぎの",
        category: "買い物",
        map: "https://goo.gl/maps/1Wd7dNhiMeGTNX3u8",
        spotify: [
          "https://open.spotify.com/embed/track/2O16qeSdWeec3Kte6TKW9p?utm_source=generator",
        ],
        content:
          "地元の名産品を取り揃えるお土産どころ、レストラン、ドッグラン、さらにはそば道場や温泉を併設する。この場所を訪れた際はちょうど猿回しが行われており、B-BOYな服を身に纏った芸猿のホープ君の軽やかな身のこなしに、Boseも思わず感心。また、地元のかたが拵えた熊本の名産品・いきなり団子を購入し、各生産者ごとのものを食べ比べをする場面も。「同じいきなり団子でも作る人でこんなに味が違うんだ」と地元の味を楽しんだ。実はここに訪れたことがあるというBose。『阿蘇ロックフェスティバル』の前夜祭として、眼前に阿蘇五岳を望む広大な芝生広場のステージに、泉谷しげるとともに立ったという。当時のことを思い出しながら、「この場所でハナレグミの『きみはぼくのともだち』の弾き語りが観られたら最高だなと思いました。満天の星空を観ながら聴きたい」と語る。",
        images: [
          "_MG_5214.jpg",
          "_MG_5239.jpg",
          "_MG_5262.jpg",
          "_MG_5220.jpg",
          "_MG_5385.jpg",
          "_MG_5357.jpg",
        ],
      },
      {
        name: "えびすぱーな 阿蘇店",
        category: "買い物",
        map: "https://goo.gl/maps/zJKMhBUtFvGDgu4v7",
        spotify: [
          "https://open.spotify.com/embed/track/5dw2Dp41BvlB3bWl6uielg?utm_source=generator",
        ],
        content:
          "「暮らしに愛を、食卓に夢を」をコンセプトに掲げる地元密着型のスーパーマーケット。その名の通り、スーパーの看板では恵比寿様が微笑む。店内は店手作りの色鮮やかなポップが目を惹き、陳列される食材に華を添える。「地元の人が毎日使うスーパーマーケットが明るく元気になるように」と、BoseはBobby Caldwellの「Saturday In the Park」を選曲。",
        images: ["bose-aso.jpg"],
      },
      {
        name: "草千里ヶ浜",
        category: "アウトドア",
        map: "https://goo.gl/maps/wPLLkxFZhR6hkjEb8",
        spotify: [
          "https://open.spotify.com/embed/track/7pN8GMLw3prWFn5nvJRM6O?utm_source=generator",
        ],
        content:
          "阿蘇山の火口跡に広がる草原。山々がそびえ立つ雄大な景観は、草千里ヶ浜へ向かう道のりから始まる。どこまでも広がる壮大な光景に「こんな山肌は初めて見ました。まるで異国の地」とBoseは興奮する。Boseが「このあたりの風景を観ながらドライブしてるときに聴きたい」1曲は、William DeVaughnの「Be Thankful For What You Got」だ。",
        images: [
          "_MG_5340.jpg",
          "_MG_5357.jpg",
          "_MG_5346.jpg",
          "_MG_5358.jpg",
        ],
      },
      {
        name: "吉一牧場",
        category: "アウトドア",
        map: "https://goo.gl/maps/NZ8mRx6982gibTnD8",
        spotify: [
          "https://open.spotify.com/embed/track/6PuIn0KCYvtSpU3kgGsDuA?utm_source=generator",
        ],
        content:
          "草千里ヶ浜から街へと下る道すがら、Boseは放牧牛と出会った。車を走らせているとふと目に入った牧場の牛たちは、驚くほど微動だにしない。突如広がった牧歌的なこの場所に、BoseはThelonious Monk「Sweet And Lovely（Take2）」を選曲する。「全く動かなくて可愛い牛のイメージです」。",
        images: ["_MG_5389.jpg", "_MG_5387.jpg"],
      },
      {
        name: "押戸石の丘",
        category: "アウトドア",
        map: "https://goo.gl/maps/f1Rzt67HyycJLFRy6",
        spotify: [
          "https://open.spotify.com/embed/track/71jnpluqHQp3Y7zHu9vz2X?utm_source=generator",
        ],
        content:
          "阿蘇は南小国町中原、マゼノ渓谷近辺の険しい道のりを往けばそこに広がるのは神秘的な絶景。草原のパノラマ風景を望む火砕流台地の小高い丘には巨石が点在する。先史時代の巨石文化遺跡であることがユネスコ岩石芸術会等で認証されており、ひとつひとつの石が意味を持つ。なかにはシュメール文字が刻まれるとする「鏡石」や方位磁石の針が乱れるほどの磁力を発する「押戸石」があり、パワースポットとしても名高い場所でもある。神秘的な押戸石の丘を表す音楽としてBoseが選んだのは、Matin Dennyの「Hypnotique」。「半信半疑だったけど、登ってみたら催眠にかかったような高揚感がありました。神秘的な場所でも怖さは感じなくて、抜けが良く晴れやかなパワースポットでしたね。風はなく、辺りも静寂に包まれていて、神様に近い場所と言われているのも納得です」。",
        images: [
          "_MG_5472.jpg",
          "_MG_5435.jpg",
          "_MG_5467.jpg",
          "_MG_5469.jpg",
          "_MG_5461.jpg",
          "_MG_5515.jpg",
          "_MG_5504.jpg",
          "_MG_5489.jpg",
        ],
      },
      {
        name: "食のひろ勝",
        category: "食事",
        map: "https://goo.gl/maps/MpRnAx5J9WT64efJ9",
        spotify: [
          "https://open.spotify.com/embed/track/2urwWshyKW7dlNCsf8H005?utm_source=generator",
        ],
        content:
          "阿蘇の夜、Boseは内牧温泉街の一角に佇む日本料理居酒屋「ひろ勝」でひと時を過ごした。ナスの揚げ浸しなどポピュラーな居酒屋メニューから、馬刺しや馬ホルモンの唐揚げといった郷土の味まで、店おすすめの料理の数々を楽しんだ。なかでも醤油と砂糖を絡めて焼いた餅に海苔を巻いた「ぽたぽた焼き」は、シメにぴったりなお腹も心も満たす一品。こんな夜にはAl Greenの「Let's Stay Together」が似合う。「甘いソウルミュージックと地元のお酒、シメはポタポタ焼き」。",
        images: [
          "_MG_5635.jpg",
          "_MG_5587.jpg",
          "_MG_5591.jpg",
          "_MG_5569.jpg",
          "_MG_5584.jpg",
        ],
      },
      {
        name: "大観峰",
        category: "アウトドア",
        map: "https://goo.gl/maps/BxDhj5885UwX7pBU7",
        spotify: [
          "https://open.spotify.com/embed/track/5Xl2WouppBdIMNZonCTR6X?utm_source=generator",
        ],
        content:
          "阿蘇の連峰を望む大観峰は、阿蘇を観光する上で定番となる場所のひとつ。最高峰からの眺望に、Boseは感動する。「流石の絶景に感服しました。気質として、定番すぎて避けてしまいそうな所ですが、例えるなら『やっぱり生で聴く大ヒット曲は凄かった』みたいな。カルデラの全貌が目で見えましたね。自然の大きさと人々の小さな暮らしの対比が見えて、自分のちっぽけさを感じましたね。カルデラの雄大さにスケールの大きなXavier Cugat『Perfidia』を」。",
        images: [
          "_MG_5673.jpg",
          "_MG_5661.jpg",
          "_MG_5667.jpg",
          "_MG_5652.jpg",
        ],
      },
      {
        name: "千羽鶴鹿公園",
        category: "アウトドア",
        map: "https://goo.gl/maps/5Xnspq9YXRWjSuCb9",
        spotify: [
          "https://open.spotify.com/embed/track/1pDYbRNVr8HmRpfl9z9x5p?utm_source=generator",
        ],
        content:
          "大観峰から黒川温泉街へ向かうやまなみハイウェイに、突如無数のトピアリー（樹木を刈り込んだ造形物）が現れた。鶴やくまモン、人の形を模したものまで、実に多くのトピアリーが立ち並ぶ光景は道ゆく者の目を惹く。加えて鹿、山羊、鶏やうさぎまで居り、それらを突然現れた猫が案内してくれるのだ。「思ったより動物たちと触れ合えて楽しめました。結局なんのための場所だったのか分からなかったのも良かったですね。猫がずっとリードしてくれたのがよかった。かわいい猫が案内してくれるという不思議体験には、坂本慎太郎の『鬼退治』が合いそう」。",
        images: ["_MG_5720.jpg", "_MG_5695.jpg", "_MG_5735.jpg"],
      },
      {
        name: "黒川温泉 お宿 のし湯",
        category: "温泉",
        map: "https://goo.gl/maps/EuWWsbM879EDt5wE7",
        spotify: [
          "https://open.spotify.com/embed/track/0oEIrVWpLj01XtFtDitQyR?utm_source=generator",
        ],
        content:
          "阿蘇の自然を堪能できる露天風呂に、木々に囲まれた静謐な空間が心を癒す「お宿 のし湯」。Boseは日帰り温泉に入浴。「露天風呂、最高でしたね。誰にでもおすすめできる」と太鼓判を押した。そして、回遊廊下や談話室、中庭など館内の情緒ある佇まいは、流れる時間をゆるやかにする。「Bill Evans Trioの『Some Other Time』のような静かなジャズでも聴きながら、ここで家族とゆったりしたい」とBoseは振り返る。",
        images: [
          "_MG_5752.jpg",
          "_MG_5866.jpg",
          "_MG_5750.jpg",
          "_MG_5887.jpg",
          "_MG_5875.jpg",
          "_MG_5823.jpg",
          "_MG_5781.jpg",
          "_MG_5852.jpg",
          "_MG_5835.jpg",
        ],
      },
      {
        name: "そば屋 沙羅",
        category: "食事",
        map: "https://goo.gl/maps/iGQoqWihpzY1fyzE6",
        spotify: [
          "https://open.spotify.com/embed/track/1XttJMNNjyhrdZEqTONgy2?utm_source=generator",
        ],
        content:
          "信州産、阿蘇産や小国産のそば粉を使用した外一そばを提供する「沙羅」。敷地内で採れた野菜やきのこの天ぷらが美味しい天そばを始め、季節限定の鴨せいろそばなどを楽しむことができる。Boseはこの場所を表す音楽にMiyoshi Umekiの「If I give my heart to you」をセレクト。「鴨せいろなのに冷たい蕎麦用のつゆも付いているというサービス精神。変化を恐れない勇気のあるお店には、ハリウッドで初めて活躍した日本人女性のミヨシウメキの歌声が似合います」。",
        images: ["_MG_5920.jpg", "_MG_5907.jpg", "_MG_5894.jpg"],
      },
      {
        name: "OGUNIYA JERSEY",
        category: "買い物",
        map: "https://g.page/ogunijersey?share",
        spotify: [
          "https://open.spotify.com/embed/track/1yPHl365z9tmhXKywwcV2q?utm_source=generator",
        ],
        content:
          "小国町の梅田牧場からその日のうちに直送される牛乳を使用した搾りたて牛乳、ホットミルクやジャージーソフトはここでしか楽しむことができない味。「ノンホモ・ジャージー・低温殺菌」の三拍子揃った牛乳は、口にすれば自然な優しい甘さが広がる。そんなOGUNIYA JERSEYの牛乳を表す1曲にBoseが選んだのはJackie Mittooの「Good Feeling」。「牛乳のまろやかなフィーリングがグッドすぎました」。",
        images: [
          "_MG_5923.jpg",
          "_MG_5942.jpg",
          "_MG_5926.jpg",
          "_MG_5984.jpg",
        ],
      },
    ],
  },
];
